var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import classNames from "classnames";
import React from "react";
import { Row, Col } from "@riseart/antd-provider";
import { InfoIcon } from "@riseart/icons";
import { messageIconWrapperCls } from "../styles.less";
import { messageCls, messageCenterCls, messagedBorderCls } from "./Message.less";
var ApplicationMessage = /* @__PURE__ */ __name(function ApplicationMessage2(_ref) {
  var _ref$border = _ref.border, border = _ref$border === void 0 ? false : _ref$border, _ref$showIcon = _ref.showIcon, showIcon = _ref$showIcon === void 0 ? true : _ref$showIcon, _ref$dismissibleCompo = _ref.dismissibleComponent, dismissibleComponent = _ref$dismissibleCompo === void 0 ? null : _ref$dismissibleCompo, children = _ref.children;
  var textSpan = 24;
  if (dismissibleComponent) {
    textSpan = showIcon ? 18 : 22;
  }
  return /* @__PURE__ */ React.createElement(Row, {
    align: "middle",
    justify: "space-around",
    className: classNames(messageCls, border && messagedBorderCls)
  }, showIcon ? /* @__PURE__ */ React.createElement(Col, {
    xs: dismissibleComponent ? 2 : 0,
    sm: dismissibleComponent ? 4 : 0,
    className: messageIconWrapperCls
  }, /* @__PURE__ */ React.createElement(InfoIcon, null)) : null, /* @__PURE__ */ React.createElement(Col, {
    span: textSpan,
    className: !dismissibleComponent || !showIcon ? messageCenterCls : ""
  }, children), dismissibleComponent || null);
}, "ApplicationMessage");
export {
  ApplicationMessage
};
